import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserInfo } from '../../../user-management.model';
import { KeyValuePipe } from '@angular/common';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'app-user-info',
  imports: [KeyValuePipe, Skeleton],
  templateUrl: './user-info.component.html',
  styleUrl: './user-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInfoComponent {
  @Input() data!: UserInfo;
  @Input() isLoading = false;
  originalOrder = () => 0;

  // Format "camelCase" or "snake_case" into readable labels
  formatLabel(key: string | number | symbol): string {
    if (key === null || key === undefined) return '';
    const k = String(key);
    return k
      .replace(/([A-Z])/g, ' $1')
      .replace(/[_-]/g, ' ')
      .replace(/^\s*/, '')
      .replace(/^./, (str) => str.toUpperCase());
  }

  formatValue(value: string | number | boolean | null | undefined): string | number | boolean | null | undefined {
    if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T/.test(value)) {
      return new Date(value).toLocaleString();
    }
    return value;
  }

  // Get all section keys dynamically
  get sectionKeys(): string[] {
    return this.data ? Object.keys(this.data) : [];
  }
}
